import {Injectable} from '@angular/core';
import {HttpInterceptorService, RESTService} from '@covalent/http-deprec';

import {HistList} from './Model/HistList';
import {environment} from '../../../../environments/environment';
import {Observable, throwError} from "rxjs/index";
import {catchError, map} from "rxjs/operators";

@Injectable()
export class HistlistService extends RESTService<HistList>{

  constructor(
    public http:HttpInterceptorService
  ) {
    super (http, {
      baseUrl: `${environment.apiHost}`,
      path: 'makpak/mphistlist'
    });
  }

  loadHistList(idOrigin: string): Observable<any>  {
    console.log("Hallo - loadHistList() im idOrigin.service.ts" + idOrigin);
    return this.http.get(`${environment.apiHost}` + '/makpak/mphistlist?idOrigin=' + idOrigin).pipe(
      map(res => res.json()),
      catchError(error => throwError(error)),
      map((result: any) => {
        if (result != null) {
          return result;
        }
        console.log(result);
      }))
  }
}
